<template>
    <div class="ui-link">
        <NuxtLink
            v-if="!isHashed"
            class="elle-btn"
            :class="[combinedClass]"
            :title="link.linkText"
            :to="useConvertedButtonLink(link)"
            :target="link.newWindow ? '_blank' : '_self'"
            data-is-btn
        >
            <span class="text">{{ link.linkText }}</span>
            <span class="icon">
                <slot name="icon">
                    <UiSvgArrowLeft />
                </slot>
            </span>
        </NuxtLink>
        <button v-else type="button" class="elle-btn" :class="[combinedClass]" :title="link.linkText" data-is-btn @click="onClick">
            <span class="text">{{ link.linkText }} </span>
            <span class="icon">
                <slot name="icon">
                    <UiSvgArrowDown />
                </slot>
            </span>
        </button>
    </div>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const props = withDefaults(
    defineProps<{
        link?: CmsItem;
        style?: string;
    }>(),
    {
        link: () => ({}),
        style: 'black'
    }
);

const dataLenis = useLenisData();
const link = computed(() => props.link);
const isHashed = computed(() => typeof link.value.linkUrl === 'string' && link.value.linkUrl.startsWith('#'));
const combinedClass = computed(() => (isHashed.value ? `${props.style} w-scroll transparent-border` : props.style));

const onClick = () => {
    if (isHashed.value) {
        const target = document.getElementById(link.value.linkUrl.substring(1));
        if (target) {
            dataLenis.value?.scrollTo(target, {
                duration: 2,
                offset: -100
            });
        }
    }
};
</script>
